// app/javascript/controllers/supply_service_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "leftControl", "rightControl", "detailText", "card"]

  
  connect() {
    this.updateControls()
    this.resizeObserver = new ResizeObserver(() => this.updateControls())
    this.resizeObserver.observe(this.containerTarget)
    
    // Initialize the first card as active
    const firstCard = this.cardTargets[0]
    if (firstCard) {
      this.activateCard(firstCard)
    }
  }

  disconnect() {
    if (this.resizeObserver) this.resizeObserver.disconnect()
  }

  // Called whenever the user scrolls manually
  scroll() {
    this.updateControls()
  }

  scrollLeft() {
    // Scroll left by approx one card width (320px)
    this.containerTarget.scrollBy({ left: -320, behavior: "smooth" })
  }

  scrollRight() {
    // Scroll right by approx one card width (320px)
    this.containerTarget.scrollBy({ left: 320, behavior: "smooth" })
  }

  updateControls() {
    const { scrollLeft, scrollWidth, clientWidth } = this.containerTarget
    
    // Buffer for sub-pixel scrolling differences
    const buffer = 10 
    const isAtStart = scrollLeft <= buffer
    const isAtEnd = Math.abs(scrollWidth - clientWidth - scrollLeft) <= buffer
    const hasOverflow = scrollWidth > clientWidth

    // If no scroll is needed (content fits), hide both controls
    if (!hasOverflow) {
      this.leftControlTarget.classList.add("hidden")
      this.rightControlTarget.classList.add("hidden")
      return
    } 

    // Otherwise show controls
    this.leftControlTarget.classList.remove("hidden")
    this.rightControlTarget.classList.remove("hidden")
      
    // Toggle opacity/pointer-events based on position
    this.toggleVisibility(this.leftControlTarget, !isAtStart)
    this.toggleVisibility(this.rightControlTarget, !isAtEnd)
  }

  toggleVisibility(element, shouldShow) {
    if (shouldShow) {
      element.classList.remove("opacity-0", "pointer-events-none")
      element.classList.add("opacity-100")
    } else {
      element.classList.add("opacity-0", "pointer-events-none")
      element.classList.remove("opacity-100")
    }
  }

  // Logic to switch the detail content
  selectCategory(event) {
    const card = event.currentTarget
    this.activateCard(card)
  }

  activateCard(card) {
   // Remove active styles from all cards
  this.cardTargets.forEach(c => {
    c.classList.remove("ring-4", "ring-ph24_new_blue/30", "border-ph24_new_blue", "z-10", "scale-[1.02]")
    c.classList.add("border-gray-200", "opacity-80") // Dim inactive cards slightly
  })

  // Add active styles to the selected card
  card.classList.add("ring-4", "ring-ph24_new_blue/30", "border-ph24_new_blue", "z-10", "scale-[1.02]", "opacity-100")
  card.classList.remove("border-gray-200", "opacity-80")

  // Update the detail text below
  if (this.hasDetailTextTarget) {
    this.detailTextTarget.textContent = card.dataset.infoText
  }
  }
}